import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  SelectInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  SearchInput,
  FunctionField,
} from 'react-admin';
import { Chip } from '@mui/material';

const transactionFilters = [
  <SearchInput
    key="search"
    source="search"
    placeholder="Search by username or chat"
    alwaysOn
  />,
  <SelectInput
    key="type"
    source="transaction_type"
    choices={[
      { id: 'prize', name: 'Prize' },
      { id: 'bet', name: 'Bet' },
      { id: 'refund', name: 'Refund' },
    ]}
    label="Type"
  />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'pending', name: 'Pending' },
      { id: 'sent', name: 'Sent' },
      { id: 'failed', name: 'Failed' },
    ]}
    label="Status"
  />,
];

const TransactionListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const StatusField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const status = record[source];
      let color: 'default' | 'primary' | 'success' | 'error' | 'warning' = 'default';

      switch (status) {
        case 'sent':
          color = 'success';
          break;
        case 'pending':
          color = 'warning';
          break;
        case 'failed':
          color = 'error';
          break;
        default:
          color = 'default';
      }

      return <Chip label={status?.toUpperCase()} color={color} size="small" />;
    }}
  />
);

const TypeField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const type = record[source];
      let color: 'default' | 'primary' | 'secondary' | 'info' = 'default';

      switch (type) {
        case 'prize':
          color = 'primary';
          break;
        case 'bet':
          color = 'info';
          break;
        case 'refund':
          color = 'secondary';
          break;
        default:
          color = 'default';
      }

      return <Chip label={type?.toUpperCase()} color={color} size="small" />;
    }}
  />
);

export const TransactionList = () => (
  <List
    filters={transactionFilters}
    actions={<TransactionListActions />}
    perPage={50}
    sort={{ field: 'created_at', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="transaction_id" label="ID" />
      <TypeField source="transaction_type" />
      <TextField source="username" />
      <TextField source="chat_title" label="Chat" />
      <NumberField
        source="amount_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Amount"
      />
      <TextField source="currency" />
      <StatusField source="status" />
      <DateField source="created_at" showTime label="Created" />
      <DateField source="paid_at" showTime label="Paid" />
    </Datagrid>
  </List>
);
